<script lang="ts">
    import {getFormatter} from "../../utils";
    import CheckoutItem from "./CheckoutItem.svelte";
    import {Cart} from "../../models/cart";

    export let cart: Cart;
    let formatter = getFormatter();
    export let costosEnvio: number = 0;
    let open = false;

    $: total = cart.count;

</script>
<div>
    <div class="bg-gray py-1 px-iii mb-15">
        <div class="box-b pointer" on:click={()=> open = !open}>
            <div class="box-l">
                <img class="chevron mr-ii" class:active={open} height="20"
                     src="/static/storefront/pix/icons/chevron-gray.svg">
                <strong>Resumen {total} Productos</strong>
            </div>
            <h3>{formatter(cart.subtotal)}</h3>
        </div>
        {#if open}
            <div class="py-15">
                {#if cart.toDelivery}
                    {#if cart.partsWithDelivery.length > 0}
                        <div>
                            <strong class="block mb-1">Productos de envío a domicilio</strong>
                            <div>
                                {#each cart.partsWithDelivery as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if cart.accessoriesToDelivery.length > 0}
                        <div>
                            <strong class="block mb-1">Accesorios de envío a domicilio</strong>
                            <div>
                                {#each cart.accessoriesToDelivery as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if cart.partsWithoutDelivery?.length > 0}
                        <div>
                            <strong class="block mb-1">Items sin envío a domicilio</strong>
                            <div>
                                {#each cart.partsWithoutDelivery as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if cart.accessoriesToInstall?.length > 0}
                        <div>
                            <strong class="block mb-1">Accesorios</strong>
                            <div>
                                {#each cart.accessoriesToInstall as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if cart.services?.length > 0}
                        <div>
                            <strong class="block mb-1">Servicios</strong>
                            <div>
                                {#each cart.services as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if cart.revisions?.length > 0}
                        <div>
                            <strong class="block mb-1">Revisiones</strong>
                            <div>
                                {#each cart.revisions as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if cart.plans?.length > 0}
                        <div>
                            <strong class="block mb-1">Planes</strong>
                            <div>
                                {#each cart.plans as product}
                                    <CheckoutItem data="{product}"/>
                                {/each}
                            </div>
                        </div>
                    {/if}
                {/if}
                <!--
                {#if cart.shipping && cart.shipping.length > 0}
                    <div>
                        <strong class="block mb-1">Productos de envío a domicilio</strong>
                        <div>
                            {#each cart.shipping as product (product.sku)}
                                <CheckoutItem data="{product}"/>
                            {/each}
                        </div>
                    </div>
                    <div class="py-ii">
                        <hr>
                    </div>
                {/if}
                {#if cart.accesories && cart.accesories.length > 0}
                    <div>
                        <strong class="block mb-1">Instalación</strong>
                        <div>
                            {#each cart.accesories as product (product.sku)}
                                <CheckoutItem data="{product}"/>
                            {/each}
                        </div>
                    </div>
                    <div class="py-ii">
                        <hr>
                    </div>
                {/if}
                {#if cart.services && cart.services.length > 0}
                    <div>
                        <strong class="block mb-1">Planes</strong>
                        {#each cart.services as product (product.sku)}
                            <CheckoutItem data="{product}"/>
                        {/each}
                    </div>
                    <div class="py-ii">
                        <hr>
                    </div>
                {/if}
                -->
                <div>
                    {#if cart.shippingCost}
                        <div class="box-b mb-1">
                            <strong>Costo de envío</strong>
                            <div style="font-size: 18px">{formatter(cart.shippingCost)}</div>
                        </div>
                    {/if}
                    <div class="box-b">
                        <strong>Impuestos</strong>
                        <div style="font-size: 18px">IVA Incluído</div>
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>
<style>
    .chevron.active {
        transform: rotate(90deg);
    }

    hr {
        background: #BDBDBD;
    }
</style>